import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Organization } from '../../data/model';
import { listTypeToChuc, ActionTable, domainMedia, domain, domainDebug } from '../../data/const';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalDialogService, SimpleModalComponent } from 'ngx-modal-dialog';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../service/common.service';
import { Paging, QueryFilter } from '../../data/dt';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit {
  @ViewChild('OrganizationModal') public OrganizationModal: ModalDirective;

  public ActionTable = ActionTable;
  public listTypeAttributeItem = [];
  public ActionId: number;
  public CheckAll: boolean;
  public listId = [];
  public domainMedia = domainMedia;
  public domain = domain;
  public Checkitem: boolean;
  public CheckitemAll: boolean;
  public isShowAction: boolean = false;
  public Item: Organization;
  public listLanguage = [];
  public listLanguageRoot = [
    { id: 1, name: 'Tiếng Việt' },
    { id: 1008, name: 'Tiếng Anh' },
  ];
  public paging: Paging;
  public q: QueryFilter;
  public languageId: number;
  public httpOptions: any;
  public listToChuc = [];
  public page_pp = [];

  public isNoitify: boolean = false;
  public staticDomain: string;
  public staticDomainMedia: string;
  public domainDebug = domainDebug;

  constructor(
    public http: HttpClient,
    public modalDialogService: ModalDialogService,
    public viewRef: ViewContainerRef,
    public toastr: ToastrService,
    public common: CommonService
  )
  {
    this.Item = new Organization();
    this.paging = new Paging();
    this.paging.page = 1;
    this.paging.page_size = 10;
    this.paging.query = "1=1";
    this.paging.order_by = "OrganizationId Desc";
    this.paging.item_count = 0;
    this.q = new QueryFilter();
    this.q.txtSearch = "";
    this.q.loaihinh = undefined;
    this.languageId = localStorage.getItem("languageId") != undefined ? parseInt(localStorage.getItem("languageId")) : 1;
    //this.paging.query = "LanguageId=" + this.languageId;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'bearer ' + localStorage.getItem("access_token")
      })
    }
  }

  ngOnInit() {
    this.GetListToChuc();
    this.GetListLanguage();
    this.GetDomainStatic();
    this.GetListTypeAttributeItem();
  }
  GetDomainStatic() {
    this.http.get('api/Config/1', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.staticDomain = res["data"].Website;
          if (res["data"].ModeSite) {
            this.staticDomainMedia = this.domainDebug + 'uploads';
            this.staticDomain = this.domainDebug;
          } else {
            this.staticDomainMedia = this.staticDomain + 'uploads';
            this.staticDomain = res["data"].Website;
          }
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }
  // Get danh sách tổ chức
  GetListToChuc() {
    this.http.get('/api/Organization/GetByPage?page=' + this.paging.page + '&page_size=' + this.paging.page_size + '&query=' + this.paging.query + '&order_by=' + this.paging.order_by, this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listToChuc = res["data"];
          this.paging.item_count = res["metadata"];
          for (let i = 0; i < this.listToChuc.length; i++) {
            this.listToChuc[i].IsCheck = false;
          }
          for (let i = 0; i < this.paging.item_count; i++) {
            this.page_pp.push(i);
          }
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }
  // Get danh sách ngôn ngữ
  GetListLanguage() {
    this.http.get('/api/Language/GetByPage?page=1&query=1=1&order_by=', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listLanguage = res["data"];
        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }
  //Get danh sách typeAttributeItem danh mục tổ chức
  GetListTypeAttributeItem() {
    this.http.get('/api/TypeAttributeItem/GetByPage?page=1&query=TypeAttributeId=27&order_by=TypeAttributeItemId Asc', this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.listTypeAttributeItem = res["data"];

        }
      },
      (err) => {
        console.log("Error: connect to API");
      }
    );
  }
  //Mở modal thêm mới
  OpenModal(item, type) {
    this.Item = new Organization();

    if (item != undefined) {
      this.Item = JSON.parse(JSON.stringify(item));
    } else {
      this.Item.LanguageId = 1;
    }
    this.OrganizationModal.show();
  }

  closeNoityfy() {
    this.isNoitify = true;
  }
  ChangeTitle(key) {
    if (this.Item.OrganizationId == undefined) {
      switch (key) {
        case 1:
          this.Item.Url = this.common.ConvertUrl(this.Item.Name);
          break;
        case 2:
          break;
        default:
          break;
      }
    }
  }
  //Chuyển trang
  PageChanged(event) {
    this.paging.page = event.page;
    this.GetListToChuc();
  }
  //Toast cảnh báo
  toastWarning(msg): void {
    this.toastr.warning(msg, 'Cảnh báo');
  }
  //Toast thành công
  toastSuccess(msg): void {
    this.toastr.success(msg, 'Hoàn thành');
  }
  //Toast thành công
  toastError(msg): void {
    this.toastr.error(msg, 'Lỗi');
  }
  SaveOrganization() {
    if (this.Item.Name == undefined || this.Item.Name == '') {
      this.toastWarning("Chưa nhập Tên!");
      return;
    } else if (this.Item.Name.replace(/ /g, '') == '') {
      this.toastWarning("Chưa nhập Tên!");
      return;
    } else if (this.Item.Address == undefined) {
      this.toastWarning("Chưa nhập địa chỉ !");
      return;
    } else if (this.Item.LanguageId == undefined) {
      this.toastWarning("Chưa chọn ngôn ngữ!");
      return;
    }
    let obj = JSON.parse(JSON.stringify(this.Item));

    if (this.Item.OrganizationId == undefined) {
      this.http.post('/api/Organization', obj, this.httpOptions).subscribe(
        (res) => {
          if (res["meta"]["error_code"] == 200) {
            this.GetListToChuc();
            this.OrganizationModal.hide();
            this.toastSuccess("Thêm mới thành công!");
          }
          else {
            this.toastError(res["meta"]["error_message"]);
          }
        },
        (err) => {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      );
    }
    else {
      this.http.put('/api/Organization/' + this.Item.OrganizationId, obj, this.httpOptions).subscribe(
        (res) => {
          if (res["meta"]["error_code"] == 200) {
            this.GetListToChuc();
            this.OrganizationModal.hide();
            this.toastSuccess(res["meta"]["error_message"]);
          }
          else {
            this.toastError(res["meta"]["error_message"]);
          }
        },
        (err) => {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      );
    }
  }

  // Chon hoac bo chon tat ca van ban
  CheckAllAddress() {
    this.listId = [];
    if (this.CheckitemAll == true) {
      for (let i = 0; i < this.listToChuc.length; i++) {
        this.listToChuc[i].IsCheck = false;
      }
    } else {
      for (let i = 0; i < this.listToChuc.length; i++) {
        this.listToChuc[i].IsCheck = true;
      }
    }

    for (let i = 0; i < this.listToChuc.length; i++) {
      if (this.listToChuc[i].IsCheck == true) {
        this.listId.push(this.listToChuc[i].OrganizationId);
      }
    }
    if (this.listId.length > 0) {
      this.isShowAction = true;
    } else {
      this.isShowAction = false;
    }
  }

  //Xoa nhieu
  DeleteMuntiAddress() {
    if (this.listId.length > 0) {
      this.http.put('/api/Organization/deletes', this.listId, this.httpOptions).subscribe(
        (res) => {
          if (res["meta"]["error_code"] == 200) {
            this.GetListToChuc();

            this.viewRef.clear();
            this.toastSuccess("Xóa thành công!");
            this.listId = [];
            this.CheckitemAll = false;
          }
          else {
            this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
          }
        },
        (err) => {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      );
    } else {
      this.toastError("Chưa có văn bản nào được chọn !");
    }
  }

  //Popup xác nhận xóa
  ShowConfirmDelete(Id) {
    this.modalDialogService.openDialog(this.viewRef, {
      title: 'Xác nhận',
      childComponent: SimpleModalComponent,
      data: {
        text: "Bạn có chắc chắn muốn xóa bản ghi này?"
      },
      actionButtons: [
        {
          text: 'Đồng ý',
          buttonClass: 'btn btn-success',
          onAction: () => {
            this.DeleteToChuc(Id);
          }
        },
        {
          text: 'Đóng',
          buttonClass: 'btn btn-danger',

        }
      ],
    });
  }

  DeleteToChuc(Id) {
    this.http.delete('/api/Organization/' + Id, this.httpOptions).subscribe(
      (res) => {
        if (res["meta"]["error_code"] == 200) {
          this.GetListToChuc();
          this.viewRef.clear();
          this.toastSuccess("Xóa thành công!");
        }
        else {
          this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
        }
      },
      (err) => {
        this.toastError("Đã xảy ra lỗi. Xin vui lòng thử lại sau!");
      }
    );
  }

  QueryChanged() {
    let query = '1=1';

    if (this.q.LanguageId != undefined) {
      query = 'LanguageId=' + this.q.LanguageId;
    }
    if (this.q.txtSearch != undefined && this.q.txtSearch != '') {
      if (query != '') {
        query += ' and Name.Contains("' + this.q.txtSearch + '")';
      }
      else {
        query += 'Name.Contains("' + this.q.txtSearch + '")';
      }
    }
    if (this.q.loaihinh != undefined) {
      query = 'TypeOrganizationId=' + this.q.loaihinh;
    }
    if (query == '')
      this.paging.query = '1=1';
    else
      this.paging.query = query;

    this.GetListToChuc();
  }
}
